export default __webpack_public_path__ + "static/media/desktop_logo.9214b5d1.svg";